import { TCoachType, TConversationCoachType } from "../state";

export const AI_COACH_GUIDE_URL =
  "https://www.enageed.jp/release-notes/260827#aifb";

export const AI_COACH_SELECT_DESCRIPTION =
  "生徒のストックのコメント欄に、選択したAIコーチからコメントが届きます。\n目的に合わせて、コーチを選択してください。\n※AIの回答は授業改善の参考情報としてご利用ください。内容が不正確な場合があります。このAIは、ENAGEEDワークスペース内のデータをモデルの学習には使用しません。";

export const AI_CONVERSATION_NOTE =
  "AIの回答は参考情報としてご利用ください。内容が不正確な場合があります。このAIは、モデルの学習には使用しません。";

export const CONVERSATION_AI_NAMES: Record<TConversationCoachType, string> = {
  gear: "GEAR",
  subject: "教科コーチ",
  writing: "文章力コーチ",
  thinking: "思考力コーチ",
};

export interface IAiCoach {
  type: TCoachType;
  name: string;
  description: string;
  exampleInput: string;
  exampleOutput: string;
}

const COACH_EXAMPLE_INPUT =
  "慣性の法則とは、静止している物体は静止し続け、動いている物体はそのまま動き続けようとする法則である。プラレールや人形を使った実験を通して、身近な現象でも慣性の法則が働いていることを学んだ。";

export const AI_COACHES: IAiCoach[] = [
  {
    type: "subject",
    name: "教科コーチ",
    description:
      "先生が生徒のストックを評価・講評するような観点で、コメントを返します。",
    exampleInput: COACH_EXAMPLE_INPUT,
    exampleOutput:
      "慣性の法則について、静止している物体と運動している物体の両方から正しく説明できています。身近な現象と結びつけている点もよいですね。さらに正確にするには、「物体に働く力の合計が0のときに、その運動状態を保つ」ことを加えてみましょう。また、「慣性の法則」と「力の合成・分解」は別の内容なので、段落を分けて整理すると理解がより明確になります。",
  },
  {
    type: "writing",
    name: "文章力コーチ",
    description:
      "国語の先生が添削するような観点で、より伝わる表現や構成を提案します。",
    exampleInput: COACH_EXAMPLE_INPUT,
    exampleOutput:
      "プラレールや人形などの具体例があり、学んだ内容をイメージしやすい文章です。一方で、一文の中に例が多く入っているため、少し読みづらくなっています。例えば、次のように分けると伝わりやすくなります。書き換え例「慣性の法則とは、物体が現在の運動状態を保とうとする法則である。授業では、プラレールや人形を使った実験から、この法則を確認した。また、摩擦のない宇宙空間でも同じ法則が働いている。」結論→具体例→考察の順に整理すると、小論文でも読み手に伝わりやすい文章になります。",
  },
  {
    type: "thinking",
    name: "思考力コーチ",
    description:
      "探究の先生が問いを返すような観点で、新たな気づきにつながるコメントを返します。",
    exampleInput: COACH_EXAMPLE_INPUT,
    exampleOutput:
      "プラレールや人形の実験から、身近な現象を同じ慣性の法則で捉えられたのは面白いですね。では、走っていたプラレールが止まってしまうのは、慣性の法則が働かなくなったからでしょうか？もし摩擦がまったくない場所だったら、どう動き続けると思いますか？地上との違いを考えてみると、慣性の法則をさらに深く理解できそうです。",
  },
];
